package com.tixforgigs.common.core.extensions

import com.tixforgigs.apax.models.Flavor
import com.tixforgigs.common.CommonBuildKonfig
import com.tixforgigs.common.http.HttpClient

object BuildKonfigUtil {

  val API_VERSION = CommonBuildKonfig.API_VERSION
  val CLIENT_VERSION = CommonBuildKonfig.CLIENT_VERSION

  val CONFIGURATOR_URL = CommonBuildKonfig.CONFIGURATOR_URL
  val STOREFRONT_URL = CommonBuildKonfig.STOREFRONT_URL

  fun calculateApiUrl(flavor: Flavor): String = when (flavor) {
    Flavor.LOCAL,
    Flavor.DEV -> CommonBuildKonfig.API_DEV_HOST + CommonBuildKonfig.API_COMMON_PATH

    Flavor.STAGING -> CommonBuildKonfig.API_STAGING_HOST + CommonBuildKonfig.API_COMMON_PATH
    Flavor.PROD -> CommonBuildKonfig.API_PROD_HOST + CommonBuildKonfig.API_COMMON_PATH
  }

  fun calculateAuthUrl(flavor: Flavor): String = when (flavor) {
    Flavor.LOCAL,
    Flavor.DEV -> CommonBuildKonfig.AUTH_DEV_HOST + CommonBuildKonfig.AUTH_DEV_PATH

    Flavor.STAGING -> CommonBuildKonfig.AUTH_STAGING_HOST
    Flavor.PROD -> CommonBuildKonfig.AUTH_PROD_HOST
  }

  fun calculateInternalApiUrl(flavor: Flavor): String = when (flavor) {
    Flavor.LOCAL -> CommonBuildKonfig.API_DEV_HOST
    else -> HttpClient.BASE_URL
  }

}